import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../shared/utility';

const initialState={
    
        filterState:'',
        whatSearch: 'Name',
        data: null
}

const reducer=(state=initialState, action)=>{
    
    switch (action.type){
            
        case actionTypes.SET_FILTER_VALUE:
            
            return updateObject(state, {filterState: action.value})
            

            
        case actionTypes.SET_FILTER_KEY:
            
            return updateObject(state, {whatSearch: action.what})
            
            
            
        case actionTypes.SET_DATA:
            
            return updateObject(state, {data: action.data})
            

            
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/search.js